module.exports = __webpack_public_path__ + "media/native-apps/linkoping-90da4df0.webp";